import styles from './styles.module.scss';
import CountryCodeSelector from './CountryCodeSelector';
import PhoneNumberInput from './PhoneNumberInput';
import { UserPhoneNumberFormCreateProps } from './PhoneNumberInput/props';

/**
 * UserPhoneNumberFormCreate Component
 * This component is responsible for rendering the form to create a user phone number.
 * It includes a country code selector and a phone number input field.
 *
 * @param {UserPhoneNumberFormCreateProps} props - The properties for the component.
 * @param {boolean} props.isKycFlow - Indicates if the form is part of the KYC (Know Your Customer) flow.
 * @param {boolean} props.isContainerColor - Determines if the container should have a specific color.
 *
 * @returns {JSX.Element} The rendered user phone number creation form component.
 *
 * @example
 * // Usage example:
 * <UserPhoneNumberFormCreate isKycFlow={true} isContainerColor={false} />
 */
export default function UserPhoneNumberFormCreate({
  isKycFlow,
  isContainerColor,
}: UserPhoneNumberFormCreateProps): JSX.Element {
  return (
    <div className={styles.container}>
      <CountryCodeSelector
        isKycFlow={isKycFlow}
        isContainerColor={isContainerColor}
      />
      <PhoneNumberInput
        isContainerColor={isContainerColor}
        isKycFlow={isKycFlow}
      />
    </div>
  );
}
